<template>
  <div class="not-box">
    <div class="not-found-img">
      <img src="@/assets/imgs/notFound_icon.png" alt="" />
    </div>
    <p>很抱歉，您访问的页面不存在</p>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.not-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  .not-found-img {
    width: 400px;
    img {
      width: 100%;
    }
  }
  p {
    font-size: 24px;
  }
}
</style>
